import { compose } from 'redux';
import type { InvitesState } from './reducer';

import type { AppState } from '../AppState';

const selectInvitesDomain = (state: AppState): InvitesState => state.invites;

export const selectLoadInvitesWebData = compose((domainState: InvitesState) => domainState.loadInvitesWebData, selectInvitesDomain);

export const selectSendInvitesWebData = compose((domainState: InvitesState) => domainState.sendInvitesWebData, selectInvitesDomain);

export const selectValidationErrors = compose((domainState: InvitesState) => domainState.validationErrors, selectInvitesDomain);

export const selectDeleteInviteWebData = compose((domainState: InvitesState) => domainState.deleteInviteWebData, selectInvitesDomain);
